import Header from './Header';
import Footer from './Footer';
import React, { createContext, Suspense, useEffect, useReducer, useState } from 'react';
import { isAuthenticated } from "../utils";
import Cookies from 'js-cookie';
import Sidebar from "./Sidebar";
import { notification } from "antd";
import { getAdminDetail } from "../api/auth";
import { setUserDetails } from "../redux/userDetails/action";
import { useDispatch } from 'react-redux';
import PopComponent from '../pages/popContent';
import CustomModal from '../hoc/CustomModal';

export const ContextState = createContext();
const reducer = (state, payload) => ({ ...state, ...payload });
const Layout = ({ children, history }) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const dispatch = useDispatch();
    const [error, setError] = useState({});
    const [modalName, setModalName] = useState("UserInfo");
    let Modal = PopComponent[modalName];
    const [openModal, setModalOpen] = useState(false);
    const [flag, setFlag] = useState(false);

    const role = Cookies.get('cms_role');
    const [contextReducer, setContextReducer] = useReducer(reducer, {
        cms_type: localStorage.getItem('cms_type') ? localStorage.getItem('cms_type') : 'skill-up'
    }, reducer);

    useEffect(() => {
        if (Cookies.get('cms_u_id')) {
            getAdminDetail(Cookies.get('cms_u_id')).then(res => {
                if (res.data.status === 200) {
                    dispatch(setUserDetails(res.data.data[0]))
                } else if (res.data.status === 103) {
                    handleOpenModal('ErrorPop', { header: "Info", body: res.data.message })
                } else {
                    handleOpenModal('ErrorPop', { header: "Error", body: res.data.message })
                }

            }).catch(err => {
                handleOpenModal('ErrorPop', { header: "Error", body: err?.response?.data?.message })
            });
        }
    }, [])

    useEffect(() => {
        if (flag)
        history.push('/users');
        else
            setFlag(true);
    }, [contextReducer])

    const handleOpenModal = (type, data) => {
        let flag = 0;
        switch (type) {
            case 'ErrorPop': {
                setModalName(type);
                setError(data)
                setModalOpen(!openModal);
                break;
            }
            default: {
                setModalName(type);
                setModalOpen(!openModal);
                break;
            }
        }
        if (flag === 1) {
            setModalName(type);
            setModalOpen(!openModal);
        }
    };

    const handleLogout = () => {
        var d = new Date(Date.now() + 12 * (60 * 60 * 1000));
        Cookies.remove('cms_access_token', { path: '/', expires: d, secure: true, sameSite: 'strict' });
        Cookies.remove('cms_u_id', { path: '/', expires: d, secure: true, sameSite: 'strict' });
        localStorage.removeItem('cms_type');
        setContextReducer({ cms_type: 'skill-up' });
        history.push('/');
    };

    notification.config({
        placement: 'topRight',
        duration: 2,
        ltr: true,
        maxCount: 3,
    });


    return (
        <ContextState.Provider value={{ contextReducer, setContextReducer }}>

            <div className="layout">
                <Header
                    history={history}
                    isAuthenticated={isAuthenticated()}
                    menuOpen={menuOpen}
                    setMenuOpen={setMenuOpen}
                    handleLogout={handleLogout}
                />

                <section className="inner_wrapper">
                    {
                        history.location.pathname !== '/sso-log' && isAuthenticated() && (
                            <Sidebar
                                history={history}
                            />
                        )
                    }
                    <Suspense fallback={""}>
                        {children}
                    </Suspense>
                </section>


                <Footer />
                {
                    Modal && (
                        <CustomModal className={`${modalName === 'EditThoughtLeader' || modalName === 'AddThoughtLeader' ? "ant-modal modal peak_model thought_leader_modal" : "modal skill_model"} ${modalName === 'ErrorPop' ? 'errorPop' : ''}`} handleOpen={handleOpenModal} open={openModal}>
                            <Modal
                                error={error}
                                handleOpenModal={handleOpenModal}
                            />
                        </CustomModal>
                    )
                }
            </div>

        </ContextState.Provider>
    )
}

export default Layout;